/* eslint-disable no-unused-vars */
import React from 'react'
import Navbarsection from '../views/Home/Navbarsection';
import Footersection from '../views/Home/Footersection';
import Our_services_hickter from '../Pages/Our_services_hickter';

function Servicesmain() {
  return (
   <>
   <Navbarsection/>
<Our_services_hickter/>
   <Footersection/>
   </>
  )
}

export default Servicesmain
